module.exports = __webpack_public_path__ + "img/new_22.e8f77374.jpg";